<template>
  <div id="moduleselector">	
    <div class="module-list" v-for="(value, name, index) in orderedObject" :key="index">
      <div>
        <div 
          class="module-list-item" :class="{'active': name == activeModule}"
          v-on:click="toggle(name)"
          v-on:contextmenu="event => activateModuleRenameField(event)"
        >
          {{name}}
        </div>
        <input
          class="module-list-item"
          v-on:change="event => renameModule(name, event)"
          v-on:blur="event => deactivateModuleRenameField(event)"
          :value="name"
          hidden />
      </div>
    </div>
    <div class="module-list-item" v-on:click="addModule" style="text-align: center; margin-top:2px;">+</div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import openModule from '../../util/openModule';
  import compile from '../../util/compile';

  let editor;
  let engine;
  let currentModule;
  let modules;

  export default {
    name: 'ModuleSelector',
    props: ['engine', 'editor', 'currentModule', 'modules', 'activeModule'],
    mounted () {
      engine = this.engine;
      editor = this.editor;
      currentModule = this.currentModule;
      modules = this.modules;

      // Store the initial list of modules in a global array
      Vue.prototype.$globalSharedData.arrayOfNamesOfCurrentlyExistingModulesWithOutputNode = this.returnArrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode();

    },

    // el: '#moduleselector',
    data()  {
      return {
        object: this.modules,
      };
    },
    computed: {
      orderedObject: function () {
        let ordered = {};
        Object.keys(this.modules).sort().forEach(key => ordered[key] = this.modules[key]);
        return ordered;
      }
    },
    methods:{
      addModule: function() {
        let moduleName = 'spurs' + Object.keys(this.modules).length + '.module';
        
        // check if module with same name exists already in object. if so, change name slightly
        let i=1;
        while(this.modules[moduleName]) {
          moduleName = moduleName+i;
          i++;
        }
        Vue.set(this.modules, moduleName, { data: {id: 'spurs@0.1.0', nodes: {}}});

        // This must happen before the this.toggle()
        // Update global variable and send out event for selectors to update options
        // Send out event (so that dropdowns can update) but also update the global variable
        let arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode= this.returnArrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode()
        Vue.prototype.$globalSharedData.arrayOfNamesOfCurrentlyExistingModulesWithOutputNode = arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode;

        this.toggle(moduleName);
      },
      returnArrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode (){

        /* 
          This method just provides an array of the names of modules which have...
          ...at least one output node. We can then use this array as the selection options...
          ...for the module node.
         */

        let arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode = []

        // Iterate over modules
        for (let [moduleName, moduleContent] of Object.entries(this.modules)) {
          // console.log(`${moduleName}: ${moduleContent}`);

          let moduleDoesNotHaveOutput = true;

          try {
              // Iterate over each node and check if it is an output one
              for (let [nodeID, nodeContent] of Object.entries(moduleContent.data.nodes)) {
                // console.log(`${nodeID}: ${nodeContent.name}`);
                // console.log('nodeContent:', nodeContent)
                if (nodeContent.name == "Output"){
                  moduleDoesNotHaveOutput = false;
                }
              }

              // If the module does NOT have NO Output node, then add it to list
              if (!moduleDoesNotHaveOutput){
                // console.log('moduleName', moduleName)
                arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode.push(moduleName)
              }
          } catch(e) {
            console.log(e)
          }

        }

        return arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode;

      },
      toggle: function(name) {

        this.$emit("update-active-module", name);

        // Update list of modules available for selection in module node
        // We do this here since toggle is also called when a project is loaded
        let arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode= this.returnArrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode()
        Vue.prototype.$globalSharedData.arrayOfNamesOfCurrentlyExistingModulesWithOutputNode = arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode;
        // Vue.prototype.$eventHub.$emit("updatedModuleNameList", arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode);

        openModule({
          name,
          engine,
          editor,
          currentModule,
          modules
        });

        // console.log('ModuleSelector toggle causes a compile.');
        // openModule already executes a compile at the end, no need to do it here again
        // compile({ engine, editor });

      },
      activateModuleRenameField: function(event) {
        event.preventDefault()
        event.target.hidden = true;
        event.target.parentNode.lastElementChild.hidden = false;
        event.target.parentNode.lastElementChild.focus();
        event.target.parentNode.lastElementChild.select();
      },
      deactivateModuleRenameField: function(event) {
        event.target.hidden = true;
        event.target.parentNode.firstElementChild.hidden = false;
      },
      renameModule: function(oldModuleName, event) {
        
        let newModuleName = event.target.value

        // If a module gets renamed to nothing, this is considered as a wish to delete this module
        if (newModuleName == null || newModuleName == "") {
          // no name means delete module
          if (confirm("Are you sure to delete module "+oldModuleName+"?")) {
            Vue.delete(this.modules, oldModuleName);

            // This must happen before the this.toggle()
            // Update global variable and send out event for selectors to update options
            // Send out event (so that dropdowns can update) but also update the global variable
            let arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode= this.returnArrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode()
            Vue.prototype.$globalSharedData.arrayOfNamesOfCurrentlyExistingModulesWithOutputNode = arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode;

            // change module in case it was the active one 
            if(this.activeModule == oldModuleName){
              // check if there is an module in the object
              if(Object.keys(this.modules).length>0){
                this.toggle(Object.keys(this.modules)[0]);
              } else {
                // no module exists, so create one
                this.addModule();
              }
            }

          } else {
            
            // The user initially created an empty name but ...
            // ... does not actually want to delete the module
            // Replace empty name with original name again
            event.target.value = oldModuleName

          }
        } else if (oldModuleName !== newModuleName) {

          // Check that the new name does not already exist
          let nameExistsAlready = false;
          // console.log(this.modules);
          for (let key in this.modules) {
            if (key == newModuleName){
              nameExistsAlready = true;
            }
          }

          if (!nameExistsAlready){
            
            // Case: Renaming of a module

            Vue.set(this.modules, newModuleName, this.modules[oldModuleName]);
            Vue.delete(this.modules, oldModuleName);

            // This must happen before the this.toggle()
            // Update global variable and send out event for selectors to update options
            // Send out event (so that dropdowns can update) but also update the global variable
            let arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode= this.returnArrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode()
            Vue.prototype.$globalSharedData.arrayOfNamesOfCurrentlyExistingModulesWithOutputNode = arrayOfNamesOfCurrentlyAvailableModulesWithAtLeastOneOutputNode;

            if(this.activeModule == oldModuleName){
              this.toggle(newModuleName);
            }

            // Recompile
            compile({ engine, editor });

                               
          } else {
            alert('This name exists already. Please choose another name.')
          }

        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #moduleselector {
    position: absolute;
    right: 5px;
    top: 64px;
    z-index: 5;
  }

  .module-list {
    padding: 2px;
    cursor: pointer;
  }
  .module-list-item {
    font-size: 1rem;
    margin-right: 0px;
    cursor: pointer;
    color: #afa2c4;
    padding: 5px 8px;
    border: 1px solid #bbb;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.8);
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .active {
    color: #51A7DD;
    border-color: #51A7DD;
    background-color: rgba(188, 221, 242, 0.3);
  }

  .module-list:hover {
    color: #a167e7;
  }
</style>


